<sc-flex vertical fitHeight stretchContent>

  <sc-dialog-title>
    <sc-dictionary-label
    dictionaryKey="tmc-yard.ui.control.sac-client.manage-planned-assignments.title"></sc-dictionary-label>
  </sc-dialog-title>


  <sc-flex-fitting-content vertical>
    <sc-padding fitHeight>

      <sc-flex [vertical]="false" fitHeight stretchContent>

        <div style="height: 100%;">
          <sc-flex vertical fitHeight stretchContent>

            <sc-sub-title>
              <sc-dictionary-label
              dictionaryKey="tmc-yard.ui.control.sac-client.manage-planned-assignments.planned-assignment-list.title"></sc-dictionary-label>
            </sc-sub-title>

            <sc-content-spacer vertical></sc-content-spacer>

            <sc-flex-fitting-content vertical>
              <sc-scroll-pane>
                <div class="transport-list">
                  @for (plannedAssignment of plannedTransportAssignments; track plannedAssignment) {
                    <app-planned-assignment-list-entry [transportDetails]="plannedAssignment.transport"
                      [selected]="selectedPlannedTransportAssignmentId != null && plannedAssignment.transportAssignmentId === selectedPlannedTransportAssignmentId"
                    (click)="setSelectedAssignment(plannedAssignment)"></app-planned-assignment-list-entry>
                    @if (selectedPlannedTransportAssignmentId != null && plannedAssignment.transportAssignmentId === selectedPlannedTransportAssignmentId) {
                      <app-planned-assignment-details-list-entry
                      [transportDetails]="plannedAssignment.transport"></app-planned-assignment-details-list-entry>
                    }
                    <sc-content-spacer vertical [half]="true"></sc-content-spacer>
                  }
                </div>
              </sc-scroll-pane>
            </sc-flex-fitting-content>

            <sc-content-spacer vertical></sc-content-spacer>

            <sc-button [disabled]="this.selectedPlannedTransportAssignmentId == null"
              dictionaryKey="tmc-yard.ui.control.sac-client.manage-planned-assignments.action.cancel-planned-assignment"
              (click)="cancelPlannedAssignment()">
            </sc-button>

          </sc-flex>
        </div>

        <sc-content-spacer></sc-content-spacer>

        <sc-flex-fitting-content>
          <div style="height: 100%;">
            <sc-flex vertical fitHeight stretchContent>

              <sc-sub-title>
                <sc-dictionary-label
                dictionaryKey="tmc-yard.ui.control.sac-client.manage-planned-assignments.planned-transports-list.title"></sc-dictionary-label>
              </sc-sub-title>

              <sc-content-spacer vertical></sc-content-spacer>

              <sc-flex-fitting-content vertical>
                <sc-scroll-pane>
                  <app-planned-transport-selection [targetStationId]="targetStation.id" [onlyPlanned]="false"
                    [findOnlyNextPlannedRoutingPosition]="false"
                  (selectedTransport)="transportSelected($event)"></app-planned-transport-selection>
                </sc-scroll-pane>
              </sc-flex-fitting-content>

              <sc-content-spacer vertical></sc-content-spacer>

              <sc-flex centered>
                <sc-button [disabled]="this.selectedTransportId == null" (click)="createPlannedAssignment()"
                  dictionaryKey="tmc-yard.ui.control.sac-client.manage-planned-assignments.action.create-planned-assignment">
                </sc-button>
              </sc-flex>
            </sc-flex>
          </div>

        </sc-flex-fitting-content>

      </sc-flex>

    </sc-padding>
  </sc-flex-fitting-content>


  <sc-padding>
    <sc-flex>
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-close-button mat-dialog-close primary></sc-close-button>
    </sc-flex>
  </sc-padding>

</sc-flex>
